export default function Hero() {
  const whatsappNumber = "5555992338351";
  const whatsappMessage = encodeURIComponent("Olá! Acabei de acessar o seu site e me interessei. Gostaria de agendar uma consulta.");

  return (
    <section className="relative min-h-screen w-full overflow-hidden flex flex-col bg-white">
      {/* Split layout: image left, content right on desktop; stacked on mobile */}
      <div className="flex flex-col lg:flex-row min-h-screen">

        {/* Image side */}
        <div className="relative w-full lg:w-1/2 h-[60vh] lg:h-auto flex-shrink-0">
          <img
            src="/img/IMG_8846.JPEG"
            alt="Dra. Leonida Fontoura - Doutora Bumbum"
            className="w-full h-full object-cover object-top"
          />
          {/* Soft gradient overlay on right edge for blending */}
          <div className="absolute inset-0 bg-gradient-to-b from-white/10 via-transparent to-white/30 lg:bg-gradient-to-r lg:from-transparent lg:to-white/20"></div>

          {/* CRM badge */}
          <div className="absolute top-6 left-6">
            <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/90 backdrop-blur-sm shadow-md border border-[#C9A84C]/30">
              <div className="w-1.5 h-1.5 rounded-full bg-[#C9A84C]"></div>
              <span className="text-[#8B6914] text-xs font-semibold tracking-widest uppercase" style={{ fontFamily: 'DM Sans, sans-serif' }}>CRM RS 58689</span>
              <div className="w-px h-3 bg-[#C9A84C]/40"></div>
              <span className="text-[#8B6914] text-xs font-semibold tracking-widest uppercase" style={{ fontFamily: 'DM Sans, sans-serif' }}>CRM SC 43471</span>
            </div>
          </div>

          {/* Stats bar at bottom of image */}
          <div className="absolute bottom-0 left-0 right-0 bg-white/90 backdrop-blur-sm border-t border-[#C9A84C]/20 px-6 py-4 lg:hidden">
            <div className="flex items-center justify-around">
              <div className="text-center">
                <p className="text-[#1a1a1a] text-xl font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>2k+</p>
                <p className="text-[#888] text-xs mt-0.5" style={{ fontFamily: 'DM Sans, sans-serif' }}>Pacientes</p>
              </div>
              <div className="w-px h-8 bg-[#C9A84C]/30"></div>
              <div className="text-center">
                <p className="text-[#1a1a1a] text-xl font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>RS•SC</p>
                <p className="text-[#888] text-xs mt-0.5" style={{ fontFamily: 'DM Sans, sans-serif' }}>Atendimentos</p>
              </div>
              <div className="w-px h-8 bg-[#C9A84C]/30"></div>
              <div className="text-center">
                <div className="flex items-center justify-center gap-0.5">
                  {[1, 2, 3, 4, 5].map(i => (
                    <i key={i} className="ri-star-fill text-[#C9A84C] text-xs"></i>
                  ))}
                </div>
                <p className="text-[#888] text-xs mt-0.5" style={{ fontFamily: 'DM Sans, sans-serif' }}>Avaliações</p>
              </div>
            </div>
          </div>
        </div>

        {/* Content side */}
        <div className="relative w-full lg:w-1/2 flex flex-col justify-center px-8 sm:px-12 lg:px-16 xl:px-20 py-16 lg:py-0 bg-white">

          {/* Decorative gold line top */}
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#C9A84C] to-transparent lg:hidden"></div>

          {/* Label */}
          <div className="flex items-start gap-3 mb-6">
            <div className="w-10 h-px bg-[#C9A84C] mt-[7px] flex-shrink-0"></div>
            <div className="flex flex-col gap-1">
              <span className="text-[#C9A84C] text-xs tracking-[0.25em] uppercase font-semibold" style={{ fontFamily: 'DM Sans, sans-serif' }}>
                Remodelação Glútea
              </span>
              <span className="text-[#C9A84C]/70 text-[11px] tracking-[0.2em] uppercase font-medium" style={{ fontFamily: 'DM Sans, sans-serif' }}>
                Emagrecimento e Performance
              </span>
              <span className="text-[#C9A84C]/70 text-[11px] tracking-[0.2em] uppercase font-medium" style={{ fontFamily: 'DM Sans, sans-serif' }}>
                Tratamento definitivo para Celulite
              </span>
            </div>
          </div>

          {/* Title */}
          <h1 className="leading-none mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            <span className="block text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-light tracking-wide text-[#1a1a1a]">Léo</span>
            <span className="block text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-[#1a1a1a]">
              <span className="text-[#C9A84C]">Dra.</span> Bumbum
            </span>
          </h1>

          {/* Divider */}
          <div className="flex items-center gap-4 mb-6">
            <div className="w-12 h-px bg-[#C9A84C]"></div>
            <div className="w-2 h-2 rounded-full bg-[#C9A84C]"></div>
            <div className="w-12 h-px bg-[#C9A84C]"></div>
          </div>

          {/* Subtitle */}
          <p className="text-[#555] text-base sm:text-lg leading-relaxed mb-4 max-w-md" style={{ fontFamily: 'DM Sans, sans-serif' }}>
            Protocolos personalizados para valorizar contorno, melhorar composição corporal e realçar resultados com segurança, técnica e naturalidade.
          </p>
          <p className="text-[#888] text-sm leading-relaxed mb-10 max-w-md" style={{ fontFamily: 'DM Sans, sans-serif' }}>
            Especialista em remodelação glútea, emagrecimento, performance e <strong className="text-[#7a6030] font-medium">tratamento avançado e definitivo para celulite</strong>, respeitando a individualidade e os objetivos de cada paciente.
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 mb-12 max-w-md">
            <a
              href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
              target="_blank"
              onclick="return gtag_report_conversion('https://wa.me/5555992338351');"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 px-7 py-4 bg-[#C9A84C] text-white text-sm font-semibold uppercase tracking-widest rounded-full hover:bg-[#b8943e] transition-all duration-300 active:scale-95 whitespace-nowrap cursor-pointer shadow-lg shadow-[#C9A84C]/30"
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              <i className="ri-calendar-check-line text-base"></i>
              Agendar Avaliação
            </a>
          </div>

          {/* Stats desktop */}
          <div className="hidden lg:flex items-center gap-8 pt-8 border-t border-[#f0e8d5]">
            <div className="text-center">
              <p className="text-[#1a1a1a] text-2xl font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>2k+</p>
              <p className="text-[#aaa] text-xs mt-0.5" style={{ fontFamily: 'DM Sans, sans-serif' }}>Pacientes</p>
            </div>
            <div className="w-px h-10 bg-[#C9A84C]/30"></div>
            <div className="text-center">
              <p className="text-[#1a1a1a] text-2xl font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>RS•SC</p>
              <p className="text-[#aaa] text-xs mt-0.5" style={{ fontFamily: 'DM Sans, sans-serif' }}>Atendimentos</p>
            </div>
            <div className="w-px h-10 bg-[#C9A84C]/30"></div>
            <div className="text-center">
              <div className="flex items-center justify-center gap-0.5 mb-0.5">
                {[1, 2, 3, 4, 5].map(i => (
                  <i key={i} className="ri-star-fill text-[#C9A84C] text-sm"></i>
                ))}
              </div>
              <p className="text-[#aaa] text-xs" style={{ fontFamily: 'DM Sans, sans-serif' }}>Avaliações</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}